/* Shared state rules. Files stay in memory; no image bytes or tokens enter storage. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.PPStudioCore = api;
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  const count = s => Math.max(1, Math.min(3, Number(s.pets) || 1));
  function selectVariant(variants, format, color, size) {
    const candidates = variants.filter(v => v.available && v.options[0] === format);
    return candidates.find(v => v.options[1] === color && v.options[2] === size)
      || candidates.find(v => v.options[2] === size)
      || candidates.find(v => v.options[1] === color) || candidates[0] || null;
  }
  function properties(s) {
    const p = {'Pet count':String(count(s)), Layout:s.layout, Background:s.background, 'Collar preference':s.collar};
    if (s.layout !== 'Portrait Only') for (let i = 0; i < count(s); i++) p[`Pet ${i+1} name`] = String(s.names?.[i] || '').trim().slice(0,40);
    if (s.layout === 'Portrait + Name + Date') p['Meaningful date'] = String(s.date || '').trim().slice(0,50);
    if (s.notes?.trim()) p['Notes'] = s.notes.trim().slice(0,500); // 28/10 QA: bỏ chữ "Artist" (luật 7)
    if (s.gift?.trim()) p['Gift note'] = s.gift.trim().slice(0,300);
    return p;
  }
  function errors(s, variant) {
    const out=[];
    if (!variant?.available) out.push('variant');
    for (let i=0; i<count(s); i++) {
      if (s.photos?.[i] !== 'ready') out.push(`photo-${i+1}`);
      if (s.layout !== 'Portrait Only' && !s.names?.[i]?.trim()) out.push(`name-${i+1}`);
    }
    if (s.layout === 'Portrait + Name + Date' && !s.date?.trim()) out.push('date');
    if (!s.confirmed) out.push('confirmation');
    return out;
  }
  function fileError(file) {
    if (!file || !file.size) return 'Choose a photo to continue.';
    if (!['image/jpeg','image/png','image/webp'].includes(file.type)) return 'Please choose a JPG, PNG or WebP photo.';
    if (file.size > 10*1024*1024) return 'Please choose a photo smaller than 10 MB.';
    return null;
  }
  function transfer(s) {
    return {pets:count(s),layout:['Portrait Only','Portrait + Name','Portrait + Name + Date'].includes(s.layout)?s.layout:'Portrait + Name',background:['Warm Ivory','Muted Sage','Dusty Blue','Soft Terracotta'].includes(s.background)?s.background:'Warm Ivory',collar:s.collar==='Remove'?'Remove':'Keep',
      names:(Array.isArray(s.names)?s.names:[]).slice(0,3).map(n=>String(n).slice(0,40)),date:String(s.date||'').slice(0,50),
      notes:String(s.notes||'').slice(0,500),gift:String(s.gift||'').slice(0,300)};
  }
  function validUpload(result,now=Date.now()) {
    return /^[A-Za-z0-9_-]{16,256}$/.test(result?.reference || '') && Number.isFinite(Date.parse(result.expires_at)) && Date.parse(result.expires_at)>now;
  }
  function readTransfer(saved,now=Date.now()) {
    return saved?.version===1 && Number.isFinite(saved.expires) && saved.expires>now && saved.state && typeof saved.state==='object' ? transfer(saved.state) : null;
  }
  function variantURL(href,id) { const url=new URL(href);url.searchParams.set('variant',String(id));return url.href; }
  function submitLatch() { let pending=false;return {begin(){if(pending)return false;pending=true;return true;},nativeBusy(busy){if(!busy)pending=false;}}; }
  return {selectVariant,properties,errors,fileError,transfer,validUpload,readTransfer,variantURL,submitLatch};
});
